import angular from 'angular';

const dependencies = ['Sq.Core', 'Sq.AppConstants', 'Sq.Workbench'];

/**
 * @module The LicenseManagement module
 */
angular.module('Sq.LicenseManagement', dependencies);
